import React, { useEffect } from 'react';
import { getLabelsByLanguage, getLanguageFromQueryParams, isRtlLanguage } from 'languages';
import { LabelsContext } from 'helpers/contexts';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { createBrowserHistory } from 'history';
import './App.css';
import SignUp from 'pages/SignUp';
import mixpanel from 'mixpanel-browser';
import * as Constant from 'constant';
import * as S from './style';

function App() {
  const language = getLanguageFromQueryParams();
  const labels = getLabelsByLanguage(language);
  const isRtl = isRtlLanguage(language);
  const history = createBrowserHistory();

  const initializeTagManager = () => {
    TagManager.initialize({
      gtmId: Constant.GTM_ID,
    });
  };

  mixpanel.init('97a365ecf38d9f133237109cfdfd0520', {
    track_pageview: true,
    persistence: 'localStorage',
  });

  useEffect(() => {
    initializeTagManager();
  }, []);

  return (
    <LabelsContext.Provider value={labels}>
      <S.AppContainer isRtl={isRtl} className="app-body">
        <BrowserRouter history={history}>
          <Switch>
            <Route path={`${Constant.ROUTE_AUTH_URL.signup.base}`}>
              <SignUp isRtl={isRtl} />
            </Route>
          </Switch>
        </BrowserRouter>
      </S.AppContainer>
    </LabelsContext.Provider>
  );
}

export default App;
